import React from "react";
import { HashRouter, Switch, Route } from "react-router-dom";
import "./sass/main.scss";
import Header from "./components/Header";
import Contact from "./components/Contact";
import Home from "./components/Home";
import Projects from "./components/Projects/Projects";
function App() {
  return (
    <HashRouter>
      <div className="App">
        <>
          <Header />
          <div className="home">
            <Switch>
              <Route exact path="/" component={Home} />
              <Route exact path="/projects" component={Projects} />
              <Route exact path="/contact" component={Contact} />
            </Switch>
          </div>
        </>
      </div>
    </HashRouter>
  );
}

export default App;
